<template>
  <div class="d-flex align-items-center gap-2">
    <div class="entries-select-wrapper">
      <hk-select v-model="optionSelected" :placeholder="$t('key_select_option')" :options="optionsRows"></hk-select>
    </div>
    <span class="text-sm text-secondary">
      {{ $t('key_text_rows_per_page') }}
    </span>
  </div>
</template>

<script>

  import HkSelect from "@/hotaka/components/HkSelect.vue"; // TODO: pulir este modulo

  export default {
    name: "EntriesPerPage",
    components:{
      HkSelect
    },
    props: {
      current: {
        type: Number,
        default: 10,
      }
    },
    emits: ['change'],
    data() {
      return {
        optionSelected: this.current,
        optionsRows: [
          { value: 5, label: "5" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 50, label: "50" },
          { value: 100, label: "100" },
          { value: 200, label: "200" },
        ]
      };
    },
    watch:{
      optionSelected(val) {
        if (val != this.current) {
          this.$emit('change', val);
        }
      },
      current(){
        this.optionSelected = this.current;
      }
    },
  };

</script>

<style scoped>

  .entries-select-wrapper {
    min-width: 90px;
    max-width: 120px;
  }

</style>